import React from "react";
import villasLocationMap from "../../assets/villas-images/villas-location-map.jpg";

export default function LocationVillas() {
  return (
    <section className="woods-location-section" id="woods-location">
      <img
        src={villasLocationMap}
        alt="Vessella Woods location map"
        className="woods-location-iframe"
        loading="lazy"
      />
    </section>
  );
}
